<template>
  <div class="popup bg-b-lue">
    <div class="frame-35628">
      <div class="title-wrapper">
        <div class="title">{{ $t("order-email") }}</div>
        <i
          class="fa-solid fa-xmark fa-xl"
          style="cursor: pointer"
          @click="close()"
        ></i>
      </div>
      <div class="user-details-wrapper" style="width: 100%">
        <div
          class="input-group1"
          style="gap: 10px; justify-content: space-between; border-radius: 13px"
        >
          <div class="input-field-title">
            {{ $t("deliver-to") }} <span style="color: red">*</span>
          </div>
          <input
            style="width: auto"
            type="text"
            v-model="deliveryEmail"
            @change="createButtonDisabled ? none : toggleConfirmDeliveryEmail"
            :placeholder="
              deliveryEmail == null
                ? $t('enter-delivery-email')
                : `${deliveryEmail}`
            "
            required
          />
        </div>
        <div
          class="input-group1"
          style="gap: 10px; justify-content: space-between; border-radius: 13px"
        >
          <div class="input-field-title">
            {{ $t("confirm-email") }} <span style="color: red">*</span>
          </div>
          <input
            :class="{ shake: shakeConfirmEmail }"
            :style="{
              width: 'auto',
              border: toggleConfirmDeliveryEmailBorder,
            }"
            type="text"
            v-model="confirmDeliveryEmail"
            @change="createButtonDisabled ? none : toggleConfirmDeliveryEmail"
            :placeholder="$t('re-enter-delivery')"
            required
          />
        </div>
      </div>
      <div class="buttons">
        <div class="cancel-button" @click="close()">
          <span>{{ $t("cancel") }}</span>
        </div>
        <div
          class="place-order-button"
          :style="{
            backgroundColor: createButtonColor,
          }"
          :disabled="createButtonDisabled"
          @click="
            createButtonDisabled
              ? shakeConfirmDelivery()
              : buyPackageAndCreateOrder()
          "
        >
          <span :style="{ color: createButtonTextColor }">{{
            isLoading ? "Placing Order......" : $t("place-order")
          }}</span>
        </div>
      </div>
    </div>
  </div>
  <Toastify ref="toastContainer" />
</template>
<script>
import Toastify from "@/components/Toastify.vue";
import { mapGetters } from "vuex";
import VueCookies from "vue-cookies";
import { CreateOrder } from "@/api/APIs";

export default {
  name: "EnterEmailModal",
  components: {
    Toastify,
  },
  props: {
    cartLoader: {
      type: Boolean,
      required: true,
    },
    reportType: {
      type: String,
    },
    companyDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      shakeConfirmEmail: false,
      deliveryEmail: VueCookies.get("email"),
      confirmDeliveryEmail: "",
      isLoading: false,
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(["userDetails"]),
    createButtonDisabled() {
      return !(
        this.isValidEmail(this.deliveryEmail) &&
        this.isValidEmail(this.confirmDeliveryEmail) &&
        this.$root.flag !== true &&
        this.deliveryEmail === this.confirmDeliveryEmail
      );
    },
    toggleConfirmDeliveryEmail() {
      return (
        this.isValidEmail(this.deliveryEmail) ==
        this.isValidEmail(this.confirmDeliveryEmail)
      );
    },
    createButtonColor() {
      return this.createButtonDisabled ? "#92c5ff" : "#046BE1";
    },
    createButtonTextColor() {
      return this.createButtonDisabled ? "#fff" : "#fff";
    },
    toggleConfirmDeliveryEmailBorder() {
      return this.toggleConfirmDeliveryEmail
        ? "1px solid #57575780"
        : "1px solid #D20D3B";
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    shakeConfirmDelivery() {
      if (this.deliveryEmail && !this.confirmDeliveryEmail) {
        this.shakeConfirmEmail = true;
        setTimeout(() => {
          this.shakeConfirmEmail = false;
        }, 500);
        return;
      }
    },
    isValidEmail(email) {
      return email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
    async buyPackageAndCreateOrder() {
      try {
        this.isLoading = true;
        const payload = {
          subjectName: this.companyDetails?.header?.company_name || "",
          subjectAddress: this.companyDetails?.header?.address || "",
          subjectCountry: this.companyDetails?.countryId || "",
          orderEmail: this.deliveryEmail || "",
          orderContactNumber: "",
          orderLandlineNumber: "",
          reportType: this.reportType || "",
          reportDetails: this.companyDetails?.priceMap?.[this.reportType] || "",
          customerName: "",
          referenceNumber: "",
          includeReferenceNumber: false,
          currencyId: 1,
          reportManual: false,
          registeredAddress: this.companyDetails?.header?.address || "",
          addressByCustomer: "",
          subjectCompanyId: this.companyDetails?.company?.keyInformation
            ?.unmasked
            ? this.companyDetails?.company?.keyInformation?.unmasked
            : this.companyDetails?.company?.keyInformation?.companyId,
          orderReferrer: "PROFILE",
        };
        const response = await CreateOrder(payload);
        if (response && response.message == "SUCCESS") {
          if (response?.result?.paymentRequired === true) {
            window.location.href = response?.result?.paymentLink;
          } else {
            this.close();
            return this.$refs.toastContainer.addToast(
            "Order Placed",
            { type: "success" }
          );
          }
        } else {
          this.close();
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style scoped>
.bg-b-lue {
  background: rgba(0, 0, 0, 8%);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  z-index: 9999;
}
.frame-35628 {
  display: flex;
  flex-direction: column;
  gap: 35px;
  align-items: center;
  justify-content: flex-start;
  /* width: 60vw; */
  position: relative;
  background: #ffffff;
  border-radius: 24px;
  min-height: 384px;
  box-shadow: 0px 24px 24px 0px rgba(17, 54, 90, 0.2);
  padding: 2rem 2rem;
}
.title-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 117px;
}
.title {
  color: var(--Dark-Blue, #224096);
  font-family: "Figtree";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  align-self: stretch;
  text-align: left;
}

.buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  align-self: stretch;
  padding: 0;
  box-shadow: none;
}
.cancel-button {
  color: #224096;
  border: 2px solid #224096;
  font-family: "Figtree";
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.16px;
  border-radius: 16px;
  padding: 8px 22px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  align-self: stretch;
  width: 50%;
}
.place-order-button {
  font-family: "Figtree";
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.16px;
  border-radius: 16px;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  align-self: stretch;
  width: 50%;
}

.user-details-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  gap: 31px;
}
.input-group1 {
  display: flex;
  flex-direction: column;
  /* width: 49%; */
  box-sizing: border-box;
}
.input-group1 input {
  padding: 10px;
  border: 1px solid rgba(87, 87, 87, 0.5);
  border-radius: 13px;
  height: 25px !important;
  box-shadow: none;
  margin: 0;
  width: -webkit-fill-available;
  outline: none;
  font-size: 16px;
}
.input-field-title {
  font-size: 16px;
  font-weight: 600;
  font-family: "Figtree";
  text-align: left;
  width: 100%;
}

@keyframes shake {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
  75% {
    transform: translateX(-5px);
  }
  100% {
    transform: translateX(0);
  }
}

.shake {
  animation: shake 0.5s;
}
@media only screen and (max-width: 767px) {
  .frame-35628 {
    width: 85vw;
    padding: 1.5rem 1rem;
    gap: 15px;
  }
  .title {
    font-size: 18px;
  }
  .add-button {
    padding: 6px 24px;
  }
  .create-button {
    padding: 8px 24px;
  }
  .cancel-button {
    padding: 6px 24px;
  }
  .input-group1 {
    width: 100% !important;
  }
  .input-group1 input {
    height: 16px !important;
    font-size: 14px;
  }
  .user-details-wrapper {
    flex-direction: column;
    gap: 10px;
  }
  .cancel-button {
    align-self: auto;
  }
  .place-order-button {
    align-self: auto;
    padding: 8px 24px;
  }
  .input-field-title {
    font-size: 14px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1156px) {
  .input-group1 input {
    padding: 5px;
  }
}
@media only screen and (min-width: 1156px) {
  .invitee-email {
    width: 40%;
  }
  .add-button {
    width: 18%;
  }
}
</style>
